import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_CUSTOMERS_QUERY_KEY } from '~/features/customers/hooks/useGetCustomers'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { Customer } from '~/supabase/types'

export const usePatchCustomer = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['patch-customer'] as const,
    mutationFn: async (payload: Partial<Customer> & { id: number }) => {
      const { id, ...updateData } = payload
      const { error } = await supabaseApi.from('customers').update(updateData).eq('id', id)

      if (error) {
        toast.error('Customer could not be updated')
        notifyError({
          data: { payload },
          error,
          message: 'Customer could not be updated',
          function: 'usePatchCustomer',
        })

        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CUSTOMERS_QUERY_KEY] })
      toast.success('Customer successfully updated')
    },
  })
}
